module.exports = __webpack_public_path__ + "static/media/kavak-vest.2c0f09ee.svg";